import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PostHogProvider } from "posthog-js/react";
import store from "./utils/store";

// PostHog configuration
const posthogOptions = {
  api_host: "https://us.i.posthog.com",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PostHogProvider
      apiKey="phc_FaML8fMhi96f5TYhjEBEupCvtODOT3HCP4gdAMM6lTO"
      options={posthogOptions}
    >
      <App />
    </PostHogProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
